<script setup lang="ts">
/**
 * The whole cookie-consent surface, mounted once in `App.vue` so the landing
 * and the game share it: the banner until a choice is stored, the preferences
 * dialog on demand, and the cookie policy opened over either. A newer
 * `COOKIE_POLICY_VERSION` clears the stored choice and the banner returns.
 */
import { computed, ref } from 'vue';

import { consent } from '@/consent/consent';
import LegalOverlay from '../LegalOverlay.vue';
import CookieBanner from './CookieBanner.vue';
import CookieSettings from './CookieSettings.vue';

/** The CMS slug of the cookie policy (seeded by `prisma/seed.ts`). */
const COOKIE_POLICY_SLUG = 'cookie-policy';

/**
 * `banner` is off at sea: the plate would sit over the battle HUD's controls.
 * The dialog stays reachable from the Settings sheet.
 */
const props = withDefaults(defineProps<{ banner?: boolean }>(), { banner: true });

const decided = computed(() => consent.record.value !== null);
const policyOpen = ref(false);
</script>

<template>
  <Teleport to="body">
    <CookieBanner v-if="props.banner && !decided && !consent.settingsOpen.value" @policy="policyOpen = true" />
  </Teleport>
  <CookieSettings @policy="policyOpen = true" />
  <LegalOverlay :slug="policyOpen ? COOKIE_POLICY_SLUG : null" @close="policyOpen = false" />
</template>
